/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer1_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer2_viewer" | "CommentContainer_viewer" | "IgnoredTombstoneOrHideContainer_viewer">;
    readonly " $refType": "ReplyListContainer1_viewer";
};
export type ReplyListContainer1_viewer$data = ReplyListContainer1_viewer;
export type ReplyListContainer1_viewer$key = {
    readonly " $data"?: ReplyListContainer1_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer1_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer1_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer2_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '6c45d55fb6e1f257fa9f4df756027211';
export default node;
